export const resolvers = {
  Mutation: {
    updateModal: (_, { open, content }, { client }) => {
      const modal = { open, content, __typename: "Modal" };
      client.writeData({ data: { modal } });
    }
  }
};
